var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assign-list"},[_vm._t("AssignmentItem")],2)}
var staticRenderFns = []

export { render, staticRenderFns }